import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, Progress, Empty, Table, Typography } from 'antd';
import api from '../../../services/api';

const { Text } = Typography;

const FrequencyTab = () => {
  const [summary, setSummary] = useState(null);
  const [timeline, setTimeline] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get('/community/player/frequency');
        setSummary(r.data?.summary || null);
        setTimeline(r.data?.timeline || []);
      } catch (err) {
        // silencioso
      }
      setLoading(false);
    })();
  }, []);

  if (loading) return <Card loading />;
  if (!summary || summary.total === 0) return <Empty description="Sem convocações registradas ainda." />;

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={12} sm={6}>
          <Card><Statistic title="Convocações" value={summary.total} /></Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card><Statistic title="Confirmei" value={summary.went} valueStyle={{ color: '#52c41a' }} /></Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card><Statistic title="Recusei" value={summary.declined} valueStyle={{ color: '#f5222d' }} /></Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card><Statistic title="Lista de espera" value={summary.waitlist} valueStyle={{ color: '#faad14' }} /></Card>
        </Col>
      </Row>

      <Card style={{ marginTop: 16 }} title="Taxa de presença">
        <Progress percent={summary.attendance_rate_pct} status="active" />
        <Text type="secondary">
          Você confirmou {summary.went} de {summary.total} convocações.
        </Text>
      </Card>

      <Card style={{ marginTop: 16 }} title="Últimos 12 meses">
        {timeline.length === 0 ? <Empty /> : (
          <Table
            pagination={false}
            size="small"
            rowKey="month"
            dataSource={timeline}
            columns={[
              { title: 'Mês', dataIndex: 'month' },
              { title: 'Convocações', dataIndex: 'total' },
              { title: 'Confirmei', dataIndex: 'went' },
              { title: 'Recusei', dataIndex: 'declined' },
            ]}
          />
        )}
      </Card>
    </>
  );
};

export default FrequencyTab;
